module.exports = __webpack_public_path__ + "mainassets/img/search.62437b68.svg";